import { useTranslation } from 'react-i18next';
import { useScheduleContext } from '@/pages/Schedule/contexts';
import { Button } from '@/ui';
import { isPollSchedule } from '@/utils/schedule';

type Props = {
  count: number;
  isPublishLoading: boolean;
  onClick: () => void;
};

export const PublishButton = ({ count, isPublishLoading, onClick }: Props) => {
  const { t } = useTranslation('addContent', { keyPrefix: 'header_card' });
  const { schedule } = useScheduleContext();
  const isPoll = Boolean(schedule && isPollSchedule(schedule));

  return (
    <Button
      _active={{ bg: undefined }}
      alignSelf={{ base: 'flex-start', md: 'center' }}
      colorScheme="dark"
      fontSize="md"
      fontWeight="bold"
      isLoading={isPublishLoading}
      loadingText={isPoll ? t('loading_text_form') : t('loading_text')}
      _hover={{
        bg: undefined,
        shadow: '0 0 8px 2px rgba(0, 0, 0, 0.15)',
      }}
      onClick={onClick}
    >
      {isPoll ? t('add_form', { count }) : t('add', { count })}
    </Button>
  );
};
